import { useSearchParams } from "react-router-dom";
import { PageTitle } from "@/components/site/PageTitle";
import { ContactForm } from "@/components/site/ContactForm";
import { CONTATTI } from "@/lib/data";

export default function Contatti() {
  const [sp] = useSearchParams();
  return (
    <div data-testid="contatti-page">
      <PageTitle title="Contattaci" crumbs={[{ label: "Contatti" }]} />
      <div className="max-w-[1240px] mx-auto px-4 pt-10 grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-10">
        <div className="max-w-[820px]">
          <p className="mb-6">Riempite il modulo qui sotto e sarete ricontattati dal nostro staff</p>
          <ContactForm key={sp.get("oggetto") || ""} oggetto={sp.get("oggetto") || ""} />
        </div>
        <aside className="text-[15px] leading-7">
          <p className="font-tit font-bold text-[var(--iv)] uppercase text-xl mb-2">IVCasa - Gruppo Immobiliare</p>
          <p>{CONTATTI.sede}</p>
          <a href={`tel:${CONTATTI.tel1.replace(/\s/g, "")}`} className="block text-[var(--iv)] text-lg font-bold">{CONTATTI.tel1}</a>
          <a href={`tel:${CONTATTI.tel2.replace(/\s/g, "")}`} className="block text-[var(--iv)] text-lg font-bold">{CONTATTI.tel2}</a>
        </aside>
      </div>
    </div>
  );
}
